import * as React from "react"

import { cn } from "@/lib/utils"

/** The multi-line counterpart to `Input`, sharing its border and ring treatment. */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-20 w-full rounded-lg border-[1.5px] border-input bg-card px-3.5 py-2.5",
        "text-base leading-relaxed text-foreground transition-colors",
        "placeholder:text-placeholder",
        "focus-ring focus-visible:border-primary",
        "aria-invalid:border-destructive aria-invalid:error-ring",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:border-border disabled:bg-muted disabled:opacity-60",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
